import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Typography, Badge, Divider } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const DateFilterMenu = ({ filters, setFilters, fetchData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isActive = !!filters.time_filter;

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleTimeFilter = (timeFilter) => {
        const newFilters = { ...filters, time_filter: timeFilter };
        setFilters(newFilters);
        handleMenuClose();
        fetchData(newFilters);
    };
    
    const clearTimeFilter = () => {
        const { time_filter, ...restFilters } = filters;
        setFilters(restFilters);
        handleMenuClose();
        fetchData(restFilters);
    };
    
    // Helper function to format time filter for display
    const formatTimeFilter = (filter) => {
        if (!filter) return "";
        return filter.replace("_", " ").replace(/\b\w/g, l => l.toUpperCase());
    };
    
    return (
        <div>
            <Badge 
                color="primary" 
                variant="dot" 
                invisible={!isActive}
                overlap="circular"
            >
                <IconButton 
                    onClick={handleMenuClick} 
                    color={isActive ? "primary" : "default"}
                    title="Filter by time period"
                >
                    <CalendarTodayIcon />
                </IconButton>
            </Badge>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                    style: {
                        borderRadius: "8px",
                        marginTop: "8px",
                        width: "240px",
                    },
                }}
            >
                <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                    Time Filter
                </Typography>
                
                {isActive && (
                    <Typography variant="body2" sx={{ px: 2, pb: 1, fontSize: '0.8rem', color: 'primary.main' }}>
                        Active: {formatTimeFilter(filters.time_filter)}
                    </Typography>
                )}
                
                <MenuItem onClick={() => handleTimeFilter("today")} className="px-3 py-2" selected={filters.time_filter === "today"}>
                    Today's News
                </MenuItem>
                <MenuItem onClick={() => handleTimeFilter("2_days")} className="px-3 py-2" selected={filters.time_filter === "2_days"}>
                    News of the past 2 Days
                </MenuItem>
                <MenuItem onClick={() => handleTimeFilter("3_days")} className="px-3 py-2" selected={filters.time_filter === "3_days"}>
                    News of the past 3 Days
                </MenuItem>
                <MenuItem onClick={() => handleTimeFilter("1_week")} className="px-3 py-2" selected={filters.time_filter === "1_week"}>
                    News of the past Week
                </MenuItem>
                
                <Divider sx={{ my: 1 }} />
                
                <MenuItem 
                    onClick={clearTimeFilter} 
                    className="px-3 py-2"
                    disabled={!isActive}
                >
                    <Typography color={isActive ? "error" : "text.disabled"}>
                        {isActive ? "Clear Time Filter" : "No Time Filter Applied"}
                    </Typography>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default DateFilterMenu;

